import ReactCalendar, { CalendarProps } from 'react-calendar'
import { CalendarWrapper } from './Styles'

const Calender = (props: CalendarProps) => (
  <CalendarWrapper>
    <ReactCalendar {...props} />
  </CalendarWrapper>
)

Calender.defaultProps = {
  locale: 'EN',
}

export default Calender
